import { render, staticRenderFns } from "./DashboardTemplate.vue?vue&type=template&id=18d8924d&"
import script from "./DashboardTemplate.vue?vue&type=script&lang=ts&"
export * from "./DashboardTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports